<template>
  <page-outline :title="$t('pain008.list_processed_file')">
    <template slot="pageContent">
      <!-- FILTRES MOBILE -->
      <div v-if="isSmartphoneOS" slot="fixed">
        <div style="position: absolute; top: 44px; width: 100%">
          <cm-messages-filter
            class="researchfilter"
            style="position: relative; z-index: 10"
            filterType="list"
            :mode="this.mode"
            :randomId="randomId"
            @applyFilter="applyFilter($event)"
            propedServiceId="9"
            :countResult="paginationObject.nbResultsTotal.toString()">
          </cm-messages-filter>
        </div>
      </div>
      <div class="listPage" style="overflow: hidden">
        <b-row>
          <b-col md="12">
            <div class="requestsList">
              <div v-if="!isSmartphoneOS">
                <cm-messages-filter
                  class="researchfilter"
                  style="position: relative; z-index: 10"
                  filterType="list"
                  :mode="this.mode"
                  :randomId="randomId"
                  @applyFilter="applyFilter($event)"
                  propedServiceId="9"
                  :countResult="paginationObject.nbResultsTotal.toString()">
                </cm-messages-filter>
              </div>
              <div v-if="isSmartphoneOS" :style="customMobileLayoutStyle"></div>
            </div>

            <br/>

            <b-row class="justify-content-center">
              <b-col sm="12">
                <hr class="w-100"/>
              </b-col>
            </b-row>

            <br/>
            <spinner v-if="activateSpinner"></spinner>
            <div v-else>
              <b-table hover responsive
                v-if="items.length"
                class="mt-3"
                :items="items"
                :fields="fields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDir"
                @head-clicked="sortTable"
                ref="tablePain008Close"
                :id="'table' + '-' + randomString">

                <template #cell(fileImport)="row">
                  <div @click="row.toggleDetails" class="cursor d-flex justify-content-between">
                    <span class="text-left" v-if="(row.item.fileImport.length > 27)">
                      {{ row.item.fileImport.substr(0,27)+ '...' }}
                    </span>
                    <span class="text-left" v-else>{{row.item.fileImport}}</span>
                    <div v-if="row.item.detailsOK.length > 0 || row.item.detailsKO.length > 0">
                      <i v-if="row.item._showDetails" class="fa-solid fa-caret-up text-primary"></i>
                      <i v-else class="fa-solid fa-caret-down"></i>
                    </div>
                  </div>
                </template>
                <template #cell(dateImport)="row_d">
                  <div class="cursor">
                    {{ row_d.item.dateImport }}
                  </div>
                </template>
                <!-- <template #cell(nbTotalElem)="row_nbe">
                  <div @click="showData(row_nbe.index)" class="cursor">{{ row_nbe.item.nbTotalElem }} </div>
                </template> -->
                <template #cell(total)="row_tot">
                    <div class="cursor">
                      {{ row_tot.item.total }}
                    </div>
                </template>
                <template #cell(erro)="row_error">
                  <div class="cursor">
                    {{ row_error.item.erro }}
                  </div>
                </template>
                <template #cell(validated)="row_va">
                  <div class="cursor">
                    {{ row_va.item.validated }}
                  </div>
                </template>
                <template #cell(verif)="row_verif">
                  <div class="cursor">
                    {{ row_verif.item.verif }}
                  </div>
                </template>
                <template #cell(refus)="row_refus">
                  <div class="cursor">
                    {{ row_refus.item.refus }}
                  </div>
                </template>
                <template #cell(globalState)="row_state">
                  <!-- <span>{{ row_state.item.GlobalState }} </span> -->
                  <div class="text-danger cursor"
                    v-if="row_state.item.globalState === $t('pain008.file_refused')">
                    {{ row_state.item.globalState }}
                  </div>
                  <div class="text-muted cursor"
                    v-else-if="row_state.item.globalState === $t('pain008.processed_pending')">
                    {{ row_state.item.globalState }}
                  </div>
                  <div v-else>
                    {{ row_state.item.globalState }}
                  </div>
                </template>
                <!-- <template #cell(FolderClose)="row_close">
                  <b-row v-if="row_close.item.FolderClose !== 'Cadenas'">
                    <b-col class="cursor">
                      <div><u>{{ row_close.item.FolderClose }}</u></div>
                    </b-col>
                  </b-row>
                  <b-row v-else>
                    <span class="cursor mx-auto"><i class="fa-duotone fa-lock text-muted text-center"></i></span>
                  </b-row>
                </template> -->

                <template #row-details="details_row">
                  <b-card class="bg-white border-0 shadow-none p-0 m-0">
                    <b-row v-for="x in details_row.item.detailsOK" :key="x"
                      class="my-1 mx-5 justify-content-center">
                      <b-col md="2" class="text-left">
                        <span class="text-success font-weight-bold">
                          {{ $t('pain008.valid_elements_reissued') }}
                        </span>
                      </b-col>
                      <b-col md="3" class="text-left">
                        {{ x.namefile }}
                      </b-col>
                      <b-col md="2" class="text-left">
                        {{ x.dateimport }}
                      </b-col>
                      <b-col md="1" class="text-left">
                        <i class="fa-light fa-arrow-right"></i>
                      </b-col>
                      <b-col md="1" class="text-left">
                        <span v-if="x.nblignes <= 1"> {{ x.nblignes }} {{ $t('pain008.line') }} </span>
                        <span v-else> {{ x.nblignes }} {{ $t('pain008.lines') }} </span>
                      </b-col>
                    </b-row>
                    <b-row v-for="x in details_row.item.detailsKO" :key="x"
                      class="my-1 mx-5 justify-content-center">
                      <b-col md="2" class="text-left">
                        <span class="text-danger font-weight-bold pt-2"> {{ $t('pain008.rejected_elements_reissued') }} </span>
                      </b-col>
                      <b-col md="3" class="text-left">
                        {{ x.namefile }}
                      </b-col>
                      <b-col md="2" class="text-left">
                        {{ x.dateimport }}
                      </b-col>
                      <b-col md="1" class="text-left">
                        <i class="fa-light fa-arrow-right"></i>
                      </b-col>
                      <b-col md="1" class="text-left">
                        <span v-if="x.nblignes <= 1"> {{ x.nblignes }} {{ $t('pain008.line') }} </span>
                        <span v-else> {{ x.nblignes }} {{ $t('pain008.lines') }} </span>
                      </b-col>
                    </b-row>
                  </b-card>
                </template>
                <template #cell(action_supp)="row_close">
                  <div v-if="row_close.item.action_supp !== 'Cadenas' && row_close.item.globalState !== 'Statut clos'">
                    <div v-if="row_close.item.action_supp === 'Clôturer le fichier'" class="cursor" @click="cloturer(row_close.item.IdFile)">
                      <u>{{ row_close.item.action_supp }}</u>
                    </div>
                    <div v-else class="cursor">
                      <u>{{ row_close.item.action_supp }}</u>
                    </div>
                  </div>
                  <div v-else>
                    <span class="cursor mx-auto">
                      <i class="fa-duotone fa-lock text-muted text-center"></i>
                    </span>
                  </div>
                </template>
              </b-table>

              <div v-else class="d-flex justify-content-center">
                <span class="noResult">
                  {{ $t('common.no_result') }}
                </span>
              </div>

              <b-row class="justify-content-end mt-5">
                <b-col xl="3" v-if="items.length">
                  <i> {{ $t('pain008.click_arrow_access_details') }} </i>
                </b-col>
                <b-col lg="2" offset="7" class="mt-3">
                  <b-button variant="primary"
                    @click="extractCSV_items()">
                    <i class="fa-solid fa-arrow-up-from-bracket"></i>
                    <span class="fab-label">{{ $t('common.extract_list') }}</span>
                  </b-button>
                </b-col>
              </b-row>

              <b-row class="mt-5">
                <b-col>
                  <b-col>
                    <cm-pagination
                      :maxResultsByPage="paginationObject.maxResults"
                      :firstIndex="paginationObject.firstIndex"
                      :nbResultsTotal="paginationObject.nbResultsTotal"
                      :refreshEvent="paginationObject.refresh">
                    </cm-pagination>
                  </b-col>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import moment from 'moment'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import MessagesFilter from '@/pages/pain008/components_Consultation/'
import pagination from '@/components/common/pagination.vue'
import Spinner from '@/components/common/spinner.vue'

export default {
  name: 'Consultations_Page',
  components: {
    'cm-messages-filter': MessagesFilter,
    'cm-pagination': pagination,
    'spinner': Spinner,
    'page-outline': PageOutline
  },
  props: {
    direction: {
      default: '2',
      type: String
    },
    modeFilter: {
      default: '1',
      type: String
    }
  },
  computed: {
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    }
  },
  data () {
  return {
    activateSpinner: false,
    filterBy: '',
    fields: [
      { key: 'fileImport', label: this.$t('pain008.nameFile'), class: 'text-center', sortable: true },
      { key: 'dateImport', label: this.$t('pain008.date_import'), class: 'text-center', sortable: true },
      { key: 'total', label: this.$t('pain008.total'), class: 'text-center' },
      { key: 'erro', label: this.$t('pain008.in_error'), class: 'text-center' },
      { key: 'validated', label: this.$t('pain008.validated'), class: 'text-center' },
      // { key: 'verif', label: this.$t('pain008.to_verify'), class: 'text-center' },
      { key: 'refus', label: this.$t('pain008.refused'), class: 'text-center' },
      { key: 'globalState', label: this.$t('pain008.stat_global'), class: 'text-center' },
      { key: 'action_supp', label: this.$t('pain008.action_supp'), class: 'text-center' }
    ],
    filterConditions: { Status: [] },
    inboxMessages: [],
    items: [],
    mode: 1,
    pageCounter: 0,
    paginationObject: {},
    randomId: Math.random().toString(36).substr(2, 10),
    requestsNumber: '',
    serviceId: this.$engine.user.currentService.id.toString(),
    serviceName: this.$t('common.appname'),
    sharedFoldersConfig: this.$engine.services.businessDocuments.sharedFoldersConfig,
    sortBy: '',
    sortDir: false,
    sortField: 'debtor_name',
    randomString: ''
    }
  },
  created () {
    let that = this

    if (this.filterConditions) {
      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }
    }

    this.reload = false
    this.randomString = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)

    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content: start',
      navTitle: this.listTitle,
      returnUrl: ''
    })

    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 13
    this.paginationObject['nbResultsTotal'] = 0

    this.paginationObject['refresh'] = 'consultation-page'
    this.$bus.$off('consultation-page')
    this.$bus.$on('consultation-page', (index) => {
      that.onRefresh(false,index)
      that.pageCounter = 0
    })

    // let that = this
    // this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    // this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage

    // this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    // this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)
    // console.log(this.paginationObject)
  },
  methods: {
    action_supp (nbverif) {
      let result = ''
      if (nbverif === '0') {
        result = this.$t('pain008.close_file_2')
      } else {
        result = ""
      }
      return result
    },
    applyFilter (filterConditions, index = 1) {
      // console.log(filterConditions)
      this.reload = true
      if (filterConditions.modeFilter !== undefined && filterConditions.modeFilter !== this.mode) {
        this.mode = filterConditions.modeFilter
      }

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0
      this.activateSpinner = true

      if (!filterConditions.Status || !filterConditions.Status.length) {
        filterConditions.Status = [5,6]
      }

      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }

      this.$engine.pain08.update(
        filterConditions,
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
      ).then(resp => {
        let requests = {}
        this.paginationObject.nbResultsTotal = resp.data.nbTotalResults
        this.paginationObject.nbResults = resp.data.Results.length
        requests = resp.data.Results
        this.updateItems(requests)
        //this.updateInbox(requests)
        this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        this.activateSpinner = false
      })
      .catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, this, this.$i18n)
      })
    },
    attachInfinit () {
      this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
      this.scrollFlag = true
      this.noMore = false
    },
    convertTime(time) {
      return (moment(time).format('DD/MM/YYYY [à] HH[h]mm'))
    },
    cloturer (idFile) {
      let status = 6
      this.idfiledata = idFile
      this.$engine.pain08.updateCloturer(this.idfiledata, status)
      this.onRefresh()
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.settings.set({sendboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    extractCSV_items () {
      let filterConditions
      if (this.reload) {
        filterConditions =
          this.$engine.pain08.filter.getConditionObject()
      } else {
        filterConditions =
          this.$engine.pain08.filter.getDefaultFilter()
      }

      if (!filterConditions.Status || !filterConditions.Status.length) {
        filterConditions.Status = [5,6]
      }

      this.$engine.pain08.update(filterConditions).then(resp => {
        let requests = {}
        requests = resp.data.Results
        this.extractData(requests)
      })
      .catch(error => {
        errorMessageAlert(error, this, this.$i18n)
      })
    },
    extractData (requests) {
      let firstLine = ''
      let lines = ''
      let fileName = ''
      let today = moment()
      firstLine = this.$t('pain008.nameFile') + ';' +
        this.$t('pain008.date_import') + ';' +
        this.$t('pain008.total') + ';' +
        this.$t('pain008.in_error') + ';' +
        this.$t('pain008.validated') + ';' +
        this.$t('pain008.refused') + ';' +
        this.$t('pain008.stat_global') + '\r\n'
      fileName = 'importedFilesList' + today.unix() + '.csv'

      for (let k in requests) {

        let dateImport = ''
        dateImport = requests[k].DateImport

        if (dateImport !== '') {
          dateImport = this.convertTime(dateImport)
        }

        let globalState = ''
        globalState = requests[k].Status
        if (globalState !== '') {
          globalState = this.globalState(globalState)
        }

        lines += requests[k].NameFile + ';' +
        dateImport + ';' +
        requests[k].NbTotal + ';' +
        requests[k].NbError + ';' +
        requests[k].NbValide + ';' +
        requests[k].NbReject + ';' +
        globalState + '\r\n'
      }
      let data = firstLine + lines
      let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
      let downloadLink = document.createElement('a')
      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },
    globalState (request) {
      let status_label = ''
      if(request === '1') {
        status_label = this.$t('pain008.processed_pending')
      } else if (request === '3') {
        status_label = this.$t('pain008.file_refused')
      } else if (request === '4') {
        status_label = this.$t('pain008.waiting_decision_2')
      } else if (request === '5') {
        status_label = this.$t('pain008.finish')
      } else if (request === '6') {
        status_label = this.$t('pain008.state_closed')
      } else if (request === '7') {
        status_label = this.$t('pain008.partially_treaty')
      } else if (request === '99') {
        status_label = this.$t('pain008.lock')
      }
      return status_label
    },
    onRefresh (noAttach = false, index = 1) {
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0
      this.activateSpinner = true
      let filterConditions

      if (this.reload) {
        filterConditions = this.$engine.pain08.filter.getConditionObject()
      } else {
        filterConditions = this.$engine.pain08.filter.getDefaultFilter()
      }


      if (!filterConditions.Status || !filterConditions.Status.length) {
        filterConditions.Status = [5,6]
      }
      // filterConditions.sortField = 'SF' + this.sortField
      // filterConditions.sortDirection = this.sortDirection

      if (this.filterConditions.OrderByField) {
        filterConditions.OrderByField = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        filterConditions.OrderByDirection = this.filterConditions.OrderByDirection
      }

      let that = this

      this.$engine.pain08.update(
        filterConditions,
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResultsTotal = resp.data.nbTotalResults

        that.paginationObject.nbResults = resp.data.Results.length

        requests = resp.data.Results
        that.updateItems(requests)
        that.$f7.pullToRefreshDone()
        that.$bus.emit('refresh-cache-paging-template', this.paginationObject)

        // this.$f7.pullToRefreshDone()

        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    sortTable (key, field, event, isFooter) {
      let sortDirection = 'ASC'
      if (key === this.sortBy && this.sortDir === false) {
        sortDirection = 'DESC'
      }

      this.filterConditions.OrderByField = key
      this.filterConditions.OrderByDirection = sortDirection

      this.applyFilter(this.filterConditions, this.paginationObject.firstIndex)
    },
    updateInbox (requests, noAttach = false) {
      this.inboxMessages = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    updateItems (requests) {
      this.items = []
      for (var i = 0; i < requests.length; i++) {
        let DetailsOK = []
        let DetailsKO = []
        if (requests[i].DetailsOK) {
          for (var j = 0; j < requests[i].DetailsOK.length; j++) {
            let dateimportOK = requests[i].DetailsOK[j].dateimport
            if (dateimportOK) {
              dateimportOK = this.convertTime(dateimportOK)
            }
            let detailsOK = {
              namefile: requests[i].DetailsOK[j].namefile,
              dateimport: dateimportOK,
              nblignes: requests[i].DetailsOK[j].nblignes
            }
            DetailsOK.push(detailsOK)
          }

          for (var z = 0; z < requests[i].DetailsKO.length; z++) {
            let dateimportKO = requests[i].DetailsKO[z].dateimport
            if (dateimportKO) {
              dateimportKO = this.convertTime(dateimportKO)
            }
            let detailsKO = {
              namefile: requests[i].DetailsKO[z].namefile,
              dateimport: dateimportKO,
              nblignes: requests[i].DetailsKO[z].nblignes
            }
            DetailsKO.push(detailsKO)
          }
        }

        let dateImport = ''
        dateImport = requests[i].DateImport

        if (dateImport !== '') {
          dateImport = this.convertTime(dateImport)
        }

        let result = {
          IdFile: requests[i].IdFile === '' ? '-' : requests[i].IdFile,
          fileImport: requests[i].NameFile === '' ? '-' : requests[i].NameFile,
          dateImport: dateImport === '' ? '-' : dateImport,
          total: requests[i].NbTotal === '0' ? '-' : requests[i].NbTotal,
          erro: requests[i].NbError === '0' ? '-' : requests[i].NbError,
          validated: requests[i].NbValide === '0' ? '-' : requests[i].NbValide,
          verif: requests[i].NbVerify === '0' ? '-' : requests[i].NbVerify,
          refus: requests[i].NbReject === '0' ? '-' : requests[i].NbReject,
          globalState: this.globalState(requests[i].Status) === '' ? '-' : this.globalState(requests[i].Status),
          action_supp: this.action_supp(requests[i].NbVerify) === '' ? '' : this.action_supp(requests[i].NbVerify),
          detailsOK : DetailsOK,
          detailsKO: DetailsKO
        }
        this.items.push(result)
      }
    }
  }
}
</script>

<style>
.cursor {
  cursor: pointer;
}
</style>
